// Trimble Maps styles configuration
// Note: Trimble Maps uses TrimbleMaps.Common.Style enum values
module.exports = [
  {
    title: 'TRANSPORTATION',
    style: 'TRANSPORTATION',
    description: 'Standard transportation map'
  },
  {
    title: 'SATELLITE',
    style: 'SATELLITE',
    description: 'Satellite imagery'
  },
  {
    title: 'TERRAIN',
    style: 'TERRAIN',
    description: 'Terrain and elevation'
  },
  {
    title: 'BASIC',
    style: 'BASIC',
    description: 'Simple base map'
  },
  {
    title: 'DATADARK',
    style: 'DATADARK',
    description: 'Dark theme for data visualization'
  },
  {
    title: 'DATALIGHT',
    style: 'DATALIGHT',
    description: 'Light theme for data visualization'
  },
  {
    title: 'OSM',
    style: {
      version: 8,
      glyphs:
        'https://maps-sdk.trimblemaps.com/v4/glyphs/{fontstack}/{range}.pbf',
      sources: {
        'osm-raster-tiles': {
          type: 'raster',
          tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
          tileSize: 256,
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }
      },
      layers: [
        {
          id: 'osm-raster-layer',
          type: 'raster',
          source: 'osm-raster-tiles',
          minzoom: 0,
          maxzoom: 22
        }
      ]
    },
    description: 'OpenStreetMap tiles'
  }
];
